import { c as _c } from "react/compiler-runtime";
type ButtonType = {
  isActive: boolean;
  label: string;
  value: Item["value"];
  onClick: (a: Item["value"]) => void;
};
const Button = properties => {
  const $ = _c(7);
  const {
    isActive,
    value,
    label,
    onClick
  } = properties;
  const t0 = `text-button flex cursor-pointer items-center justify-center rounded-md border-2 px-4 py-2 ${isActive ? "border-on-surface-secondary-high-emphasis text-secondary rounded-md border-2" : "border-transparent"}`;
  let t1;
  if ($[0] !== onClick || $[1] !== value) {
    t1 = () => onClick(value);
    $[0] = onClick;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== label || $[4] !== t0 || $[5] !== t1) {
    t2 = <button className={t0} onClick={t1}>{label}</button>;
    $[3] = label;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
type Item = {
  label: string;
  value?: string;
};
type ToggleButtonTypes = {
  items: Array<Item>;
  activeItem: Item["value"];
  onChange: (a: Item["value"]) => void;
};
export const ToggleButtons = properties => {
  const $ = _c(9);
  const {
    items,
    activeItem,
    onChange
  } = properties;
  let t0;
  if ($[0] !== activeItem || $[1] !== items || $[2] !== onChange) {
    let t1;
    if ($[4] !== activeItem || $[5] !== onChange) {
      t1 = item => <Button isActive={activeItem === item.value} key={item.label} label={item.label} onClick={onChange} value={item.value} />;
      $[4] = activeItem;
      $[5] = onChange;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    t0 = items.map(t1);
    $[0] = activeItem;
    $[1] = items;
    $[2] = onChange;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[7] !== t0) {
    t1 = <div className="border-outline-thin flex rounded-lg border">{t0}</div>;
    $[7] = t0;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
};